import { API_ERRORS } from '@/constants'
import { NullableType } from '@/models'

export const getApiErrorStatus = <T extends Array<NullableType<Error>>>(
  // NOTE: special guard check to ensure at least one argument is passed in the end
  ...errors: T extends [] ? never : T
): number => {
  const foundError = errors.find((error) => typeof error?.request?.status == 'number')
  return foundError?.request?.status || API_ERRORS.NONE
}
